/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const routineCreateBodyStartLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const routineCreateBodyAnchorClockLocalRegExp = new RegExp('^(?:[01]\\d|2[0-3]):[0-5]\\d$');
export const routineCreateBodyRotationCountExclusiveMin = 0;
export const routineCreateBodyRotationCountMax = 2147483647;

export const routineCreateBodySectionsItemStartWeekdayMax = 7;

export const routineCreateBodySectionsItemStartLocalMinuteMin = 0;
export const routineCreateBodySectionsItemStartLocalMinuteMax = 1439;

export const routineCreateBodySectionsItemEndWeekdayMax = 7;

export const routineCreateBodySectionsItemEndLocalMinuteMin = 0;
export const routineCreateBodySectionsItemEndLocalMinuteMax = 1439;

export const routineCreateBodySectionsItemFullWeekDefault = false;
export const routineCreateBodySectionsMax = 14;

export const routineCreateBodyParticipantsItemOrdinalMin = 0;
export const routineCreateBodyParticipantsItemOrdinalMax = 19;

export const routineCreateBodyParticipantsItemUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const routineCreateBodyParticipantsMax = 20;

export const routineCreateBodyEndedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const routineCreateBodyExpectedVersionExclusiveMin = 0;
export const routineCreateBodyExpectedVersionMax = 9007199254740991;

export const RoutineCreateBody = zod.object({
  name: zod.string(),
  startLocalDate: zod.iso.date().regex(routineCreateBodyStartLocalDateRegExp),
  anchorClockLocal: zod.string().regex(routineCreateBodyAnchorClockLocalRegExp),
  rotation: zod.object({
    unit: zod.enum(['day', 'week']),
    count: zod
      .int()
      .gt(routineCreateBodyRotationCountExclusiveMin)
      .max(routineCreateBodyRotationCountMax),
  }),
  sections: zod
    .array(
      zod.object({
        startWeekday: zod.int().min(1).max(routineCreateBodySectionsItemStartWeekdayMax),
        startLocalMinute: zod
          .int()
          .min(routineCreateBodySectionsItemStartLocalMinuteMin)
          .max(routineCreateBodySectionsItemStartLocalMinuteMax),
        endWeekday: zod.int().min(1).max(routineCreateBodySectionsItemEndWeekdayMax),
        endLocalMinute: zod
          .int()
          .min(routineCreateBodySectionsItemEndLocalMinuteMin)
          .max(routineCreateBodySectionsItemEndLocalMinuteMax),
        fullWeek: zod.boolean().default(routineCreateBodySectionsItemFullWeekDefault),
      }),
    )
    .min(1)
    .max(routineCreateBodySectionsMax),
  participants: zod
    .array(
      zod.object({
        ordinal: zod
          .int()
          .min(routineCreateBodyParticipantsItemOrdinalMin)
          .max(routineCreateBodyParticipantsItemOrdinalMax),
        userId: zod.uuid().regex(routineCreateBodyParticipantsItemUserIdRegExp),
      }),
    )
    .min(1)
    .max(routineCreateBodyParticipantsMax),
  endedAt: zod
    .union([
      zod.iso.datetime({ offset: true }).regex(routineCreateBodyEndedAtOneRegExp),
      zod.null(),
    ])
    .optional(),
  teamId: zod.unknown().optional(),
  scheduleId: zod.unknown().optional(),
  expectedVersion: zod
    .int()
    .gt(routineCreateBodyExpectedVersionExclusiveMin)
    .max(routineCreateBodyExpectedVersionMax),
});

export type RoutineCreateBody = zod.input<typeof RoutineCreateBody>;
export type RoutineCreateBodyOutput = zod.output<typeof RoutineCreateBody>;
